import { useContext } from 'react';
import { LogContext, LogContextType } from '../contexts/LogContext';

export const useLogContext = () => {
    return useContext(LogContext) as LogContextType;
};
